import { render, staticRenderFns } from "./LocationInvoiceAgeingDashboard.vue?vue&type=template&id=05c25107&"
import script from "./LocationInvoiceAgeingDashboard.vue?vue&type=script&lang=js&"
export * from "./LocationInvoiceAgeingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports